import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    title: String,
    metricRange: Object,
    calibrationId: Number,
    calibration: Object,
    newMeasurementModel: Object,
    ranges: Array,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.getCalibrationPattern()
    this.currentCalibration.id = this.calibrationId

    if (this.ranges) {
      if (
        this.ranges.filter((x) => x.calibrationPatternTemplateParameter != null)
          .length > 0
      ) {
        this.ranges
          .map((x) => x.calibrationPatternTemplateParameter)
          .forEach((item) => {
            var duplicated =
              this.distinctRanges.findIndex((redItem) => {
                return item.id == redItem.id
              }) > -1

            if (!duplicated) {
              this.distinctRanges.push(item)
            }
          })
      } else {
        this.distinctRanges = this.ranges
      }
    }

    if (this.calibration) {
      this.currentCalibration = this.calibration
    }

    if (this.metricRange) {
      this.currentMetricRange = this.metricRange
      this.calibrationPatternMetricsRange =
        this.metricRange.calibrationPatternMetricsRange
      this.currentCalibration.id = this.metricRange.calibrationId
      this.valueOne = this.metricRange.valueOne
      this.valueTwo = this.metricRange.valueTwo
      this.valueThree = this.metricRange.valueThree
      this.valueFour = this.metricRange.valueFour
      this.valueFive = this.metricRange.valueFive
      this.k = this.metricRange.k
      this.uncertainty = this.metricRange.uncertainty
      this.tendency = this.metricRange.tendency
      this.range = this.metricRange.range
      this.calibrationPatternId =
        this.metricRange.calibrationPatternMetricsRange.calibrationPatternMetrics.calibrationPatternId
      await this.listCalibrationMetrics()
      this.calibrationPatternMetric =
        this.metricRange.calibrationPatternMetricsRange.calibrationPatternMetrics
      this.getResolution()
      this.resolutionEquipment = this.getResolutionEquipment(
        this.metricRange.calibrationPatternTemplateParameterId
      )
      this.currentCalibrationPatternTemplateParameter =
        this.metricRange.calibrationPatternTemplateParameter
      this.isEditing = true
    }

    if (this.newMeasurementModel) {
      this.measurementModel = this.newMeasurementModel
      this.calibrationPatternId = this.measurementModel.CalibrationPatternId
      await this.listCalibrationMetrics()
      this.calibrationPatternMetric =
        this.measurementModel.CalibrationPatternTemplateParametersMetricsRanges.calibrationPatternMetricsRange.calibrationPatternMetrics
      this.getResolution()
      this.resolutionEquipment = this.measurementModel.ResolutionEquipment
      this.currentCalibrationPatternTemplateParameter =
        this.measurementModel.Parameter
      this.calibrationPatternMetricsRange =
        this.measurementModel.CalibrationPatternTemplateParametersMetricsRanges.calibrationPatternMetricsRange
      this.inputDisabled = true
      this.newMeasurement = true
    }
  },

  data: () => ({
    institution: {},
    step: 0,
    errorMessage: '',
    loading: false,
    deleteLoading: false,
    calibrationPatternLoading: false,
    calibrationMetricsLoading: false,
    firstValid: true,
    alterDialog: false,
    deleteDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    inputDisabled: false,
    newMeasurement: false,
    changeEquipmentResolution: false,
    valueOne: '',
    valueTwo: '',
    valueThree: '',
    valueFour: '',
    valueFive: '',
    k: '',
    uncertainty: '',
    tendency: '',
    resolutionEquipment: '',
    resolutionPattern: '',
    range: '',
    distinctRanges: [],
    institutionId: null,
    currentCalibrationPatternTemplateParameter: {
      id: 0,
      fixedValue: false,
      name: '',
      tolerance: '',
    },
    calibrationPatternMetricsRange: {
      id: 0,
      range: '',
      k: '',
      uncertainty: '',
      tendency: '',
    },
    calibrationPatternId: null,
    calibrationPatterns: [],
    calibrationPatternMetric: null,
    calibrationPatternMetrics: [],
    currentCalibration: {},
    currentMetricRange: {},
    measurementModel: {},
    userLogged: {},
    metricRanges: [],
    nameRules: [
      (v) => !!v || 'Parâmetro requerido',
      (v) =>
        (v && v.length <= 128) || 'Parâmetro deve ter no máximo 128 caracteres',
    ],
    calibrationPatternRulles: [(v) => !!v || 'Padrão requerido'],
    calibrationMetricRulles: [(v) => !!v || 'Métrica requerida'],
    toleranceRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Tolerância requerida',
    ],
    rangeRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Faixa é requerida',
    ],
    kRules: [(v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'K é requerido'],
    uncertaintyRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Incerteza é requerida',
    ],
    tendencyRules: [
      (v) => parseInt(v) >= 0 || parseInt(v) <= 0 || 'Tendência é requerida',
    ],
    resolutionEquipmentRules: [
      (v) => !!v || 'Resolução equipmento é requerida',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados Medição'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    changePattern() {
      this.listCalibrationMetrics()
      this.calculateInterpolation(this.range)
    },

    changeMetric() {
      this.getResolution()
      this.calculateInterpolation(this.range)
    },

    async getCalibrationPattern() {
      this.calibrationPatternLoading = true

      await this.apiService.get(`calibrationPattern/list/`).then((response) => {
        this.calibrationPatterns = response.content
        this.calibrationPatternLoading = false
      })
    },

    async listCalibrationMetrics() {
      await this.apiService
        .get(`calibrationPatternMetrics/list/${this.calibrationPatternId}`)
        .then((response) => {
          this.calibrationPatternMetrics = response.content
        })
    },

    getResolution() {
      this.resolutionPattern = this.calibrationPatternMetrics.find(
        (x) => x.id === this.calibrationPatternMetric.id
      ).resolution
    },

    getResolutionEquipment(value) {
      const parameter = this.currentCalibration.templateParameters.find(
        (x) => x.calibrationPatternTemplateParameterId === value
      )
      if (parameter) {
        return parameter.resolutionEquipment
      }
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const calibrationPatternTemplateParameter =
        this.currentCalibrationPatternTemplateParameter

      const calibrationPatternMetricRange = {
        Id: this.calibrationPatternMetricsRange.id,
        Range: this.range,
        K: this.k,
        Uncertainty: this.uncertainty,
        Tendency: this.tendency,
        CalibrationPatternMetricsId: this.calibrationPatternMetric.id,
      }

      const calibrationNewMeasurementModel = {
        CalibrationId: this.currentCalibration.id,
        CalibrationPatternId: this.calibrationPatternId,
        CalibrationPatternMetricId: this.calibrationPatternMetric.id,
        CalibrationPatternMetricsRange: calibrationPatternMetricRange,
        CalibrationPatternTemplateParameter:
          calibrationPatternTemplateParameter,
        ResolutionEquipment: this.resolutionEquipment,
        ValueOne: this.valueOne,
        ValueTwo: this.valueTwo,
        ValueThree: this.valueThree,
        ValueFour: this.valueFour,
        ValueFive: this.valueFive,
      }

      if (this.newMeasurement) {
        calibrationPatternMetricRange.Id = 0
        await this.apiService
          .post(
            'calibrationPatternMetricsRange/add',
            calibrationPatternMetricRange
          )
          .then((response) => {
            calibrationPatternMetricRange.Id = response.content.id
            const newRange = {
              CalibrationPatternMetricRange: calibrationPatternMetricRange,
              CalibrationPatternMetric: this.calibrationPatternMetric,
              CalibrationPatternTemplateParameter:
                calibrationPatternTemplateParameter,
              ValueOne: this.valueOne,
              ValueTwo: this.valueTwo,
              ValueThree: this.valueThree,
              ValueFour: this.valueFour,
              ValueFive: this.valueFive,
              ResolutionEquipment: this.resolutionEquipment,
            }
            this.$emit('addNewRange', { range: newRange })
            this.newMeasurement = false
            this.closeDialog()
          })
      } else {
        let url = 'calibration/newMeasurement'

        if (this.isEditing) {
          url = 'calibration/editMeasurement'
        } else {
          calibrationNewMeasurementModel.CalibrationPatternTemplateParameter.id =
            undefined
          calibrationNewMeasurementModel.CalibrationPatternTemplateParameter.calibrationPattern =
            undefined
        }

        await this.apiService
          .post(url, calibrationNewMeasurementModel)
          .then((response) => {
            this.step++

            this.loading = false
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            this.loading = false
            this.changedData = false

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    async removeMeasurement() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibration/deleteMeasurement', this.metricRange)
        .then((response) => {
          sessionStorage.clear()
          sessionStorage.setItem(
            'calibration',
            JSON.stringify(response.content)
          )
          this.closeDialog()
        })
    },

    async calculateInterpolation(newRange) {
      if (newRange) {
        const model = {
          CalibrationPatternId: this.calibrationPatternId,
          CalibrationPatternMetricsId: this.calibrationPatternMetric.id,
          NewRange: newRange,
        }

        await this.apiService
          .post('calibration/calculateInterpolation', model)
          .then((response) => {
            this.k = response.content.k
            this.uncertainty = response.content.uncertainty
            this.tendency = response.content.tendency
            this.$forceUpdate()
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },
  },

  watch: {
    calibrationPatternId: {
      deep: true,
      handler() {
        if (this.isEditing) {
          this.changedData = true
        }
      },
    },
  },
}
